/**
 * ApplicationsFilters — две группы чипов над очередью: статус и
 * происхождение заявки.
 *
 * Счётчик стоит только у статусов, и только там он имеет смысл: бэк
 * считает `statusCounts` с учётом выбранного происхождения, но без
 * учёта самого статуса. Поставить цифру рядом с «Из приложения» было
 * бы нечем — такого счётчика в ответе нет, а считать его по текущей
 * странице означало бы показать «7» там, где заявок семьдесят.
 */

import {cn} from '@lib/utils';

import {
  FILTER_CHIPS,
  SOURCE_CHIPS,
  type SourceFilter,
  type StatusFilter,
} from '../Applications.utils';

type Props = {
  status: StatusFilter;
  source: SourceFilter;
  countOf: (key: StatusFilter) => number;
  onStatus: (v: StatusFilter) => void;
  onSource: (v: SourceFilter) => void;
};

const CHIP =
  'rounded-full border border-skr-line bg-card text-[12.5px] font-medium text-muted-foreground transition';
const ACTIVE = 'border-primary bg-accent font-semibold text-primary';

export const ApplicationsFilters = ({status, source, countOf, onStatus, onSource}: Props) => (
  <>
    <div className="mb-4 flex flex-wrap gap-2">
      {FILTER_CHIPS.map((c) => (
        <button
          key={c.key}
          onClick={() => onStatus(c.key)}
          className={cn(
            CHIP,
            'flex items-center gap-1.5 px-3.5 py-[7px]',
            status === c.key && ACTIVE,
          )}
        >
          {c.label}
          <span className="font-mono text-[11.5px]">{countOf(c.key)}</span>
        </button>
      ))}
    </div>

    <div className="mb-4 flex flex-wrap items-center gap-2">
      <span className="text-[11.5px] font-semibold uppercase tracking-[.05em] text-skr-label">
        Откуда
      </span>
      {SOURCE_CHIPS.map((c) => (
        <button
          key={c.key}
          onClick={() => onSource(c.key)}
          className={cn(CHIP, 'px-3.5 py-[6px]', source === c.key && ACTIVE)}
        >
          {c.label}
        </button>
      ))}
    </div>
  </>
);
